export const SET_SIDEBAR_SHOW = "set";
export const ADD_TOAST = "add-toast";
export const REMOVE_TOAST = "remove-toast";
export const UPDATE_CURRENT_USER = "update-current-user";
